import ApiMakes from '../../api/makes';

const getMakesStarted = () => ({
    type: 'GET_MAKES_STARTED'
});

const getMakesSuccess = items => ({
    type: 'GET_MAKES_SUCCESS',
    payload: items
});

const getMakesFailure = error => ({
    type: 'GET_MAKES_FAILURE',
    payload: { error }
});

const getMakes = () => {

    return dispatch => {

        dispatch(getMakesStarted());

        ApiMakes.get()
            .then(json =>  {
                const items = json.makes;
                dispatch(getMakesSuccess({ items })) 
            })
            .catch(error => dispatch(getMakesFailure(error)));            

    }
    
}

const setSelectedMake = make => {
    return {
        type: 'SET_SELECTED_MAKE',
        payload: make
    }
}

export default { getMakes, setSelectedMake };